import { createEntityAdapter } from "@reduxjs/toolkit";
import { ControlPointPassage } from "./dataTypes";

export const controlPointPassageAdapter = createEntityAdapter<ControlPointPassage>({});
